export enum TransactionStatus {
    Successful = 'Successful',
    Pending = 'Pending',
    Failed = 'Failed',
  }